/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import styles from './styles';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Dashboard as DashboardLayout } from 'layouts';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SpeedDial,
  SpeedDialAction,
  Typography,
} from '@mui/material';
import { showMeters } from 'js/actions/meterActions';
import { showGroups } from 'js/actions/groupActions';
import { showCharge } from 'js/actions/chargeActions';
import Swal from 'sweetalert2';
import axios from 'axios';
import getToken from 'helpers/auth';
import { Link } from 'react-router-dom';
import {
  DataGrid,
  gridPageCountSelector,
  GridPagination,
  GridToolbarQuickFilter,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import { getColumns } from './columns';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import SendInvoice from './SendInvoice';
import { Email, Settings } from '@mui/icons-material';
const useStyles = makeStyles(styles);
import MuiPagination from '@mui/material/Pagination';
import { EmptyTable } from 'components/EmptyTable';

// Componente de la barra de búsqueda rápida en el toolbar
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="h6">
        {useIntl().formatMessage({ id: 'app.invoices.grid.title' })}
      </Typography>
      <GridToolbarQuickFilter /> {/* Barra de búsqueda rápida de la tabla */}
    </Box>
  );
}

function Pagination({ page, onPageChange, className }) {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      color="primary"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
}

export default function Invoice() {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();
  const { corporatives } = useSelector((state) => state.corporatives);
  const { meters } = useSelector((state) => state.meters);
  let { groups } = useSelector((state) => state.groups);
  let { charges } = useSelector((state) => state.charges);
  const { user } = useSelector((state) => state.user);

  const [corporative, setCorporative] = useState();
  const [meter, setMeter] = useState();
  const [group, setGroup] = useState();
  const [charge, setCharge] = useState([]);
  const [year, setYear] = useState();
  const [month, setMonth] = useState();
  const [blocking, setBlocking] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState();
  const [open, setOpen] = useState();

  const corpUser = user.corporative;
  const currYear = new Date().getFullYear();
  const years = [currYear - 3, currYear - 2, currYear - 1, currYear];

  useEffect(() => {
    if (user.adser != 1 && corpUser) {
      getMeters(corpUser.id);
    }
  }, []);

  const onSubmit = (report) => {
    setData([]);
    setBlocking(true);
    dispatch(doSearch(report));
  };

  function doSearch() {
    setData([]);
    return async () => {
      axios({
        method: 'post',
        url: 'https://api.metimur.mx/api/invoice/files',
        data: {
          corporative_id: corporative,
          meter_id: meter,
          group_id: group,
          charges_ids: charge,
          year: year,
          month: month,
        },
        headers: {
          Authorization: 'Bearer ' + getToken(),
        },
      })
        .then(function (response) {
          setData(response.data.data);
          endBlocking();
        })
        .catch(function () {
          setBlocking(false);
          Swal.fire({
            title: '',
            text: intl.formatMessage({ id: 'app.invoices.error' }),
            icon: 'error',
          });
        });
    };
  }

  function endBlocking() {
    setBlocking(false);
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: 'success',
      title: 'Información Obtenida Correctamente',
    });
  }

  const getMeters = (corporativeId) => {
    dispatch(showMeters(corporativeId));
  };

  const getGroup = (meterId) => {
    dispatch(showGroups(meterId));
  };

  const getCharges = (groupId) => {
    const p = [];
    p[0] = groupId;
    dispatch(showCharge(p));
  };

  const handleCorporative = (corporative) => {
    setCorporative(corporative.target.value);
    setCharge([]);
    setGroup(null);
    getMeters(corporative.target.value);
  };

  const handleMeter = (meter) => {
    setMeter(meter.target.value);
    setCharge([]);
    setGroup(null);
    getGroup(meter.target.value);
  };

  const handleGroup = (group) => {
    setGroup(group.target.value);
    setCharge([]);
    getCharges(group.target.value);
  };

  const handleCharge = (chargeVal) => {
    setCharge(chargeVal.target.value);
  };

  const handleYear = (year) => {
    setYear(year.target.value);
  };

  const handleMonth = (month) => {
    setMonth(month.target.value);
  };

  const getSelector = (corp) => {
    if (corp == 1) {
      return (
        <FormControl
          className={classes.textField}
          variant="outlined"
          fullWidth={true}
        >
          <InputLabel id="demo-simple-select-outlined-label">
            {intl.formatMessage({ id: 'app.invoices.corporateLbl' })}
          </InputLabel>
          <Select
            id="demo-simple-select-outlined"
            {...register('corporative')}
            labelId="demo-simple-select-outlined-label"
            name="corporative"
            onChange={handleCorporative}
            value={corporative}
            input={
              <OutlinedInput
                label={intl.formatMessage({
                  id: 'app.reports.hourReports.corporateLbl',
                })}
              />
            }
          >
            {corporatives?.map((el) => (
              <MenuItem value={el.id} key={el.id}>
                {el.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    } else {
      return null;
    }
  };

  function CustomFooterDownloadComponent() {
    return (
      <Box p={1} display="flex" justifyContent="center" alignItems="center">
        <DownloadButton selectedRows={selectedRows} allRows={data} />
        <GridPagination ActionsComponent={Pagination} />
      </Box>
    );
  }

  const handleRowSelect = (rows) => {
    setSelectedRows(rows);
  };

  const invoiceName = () => {
    const nameZip = [];
    const groupName = groups.find((groupId) => groupId.id === group);
    const meterObj = meters.find((meterId) => meterId.id === meter);
    const meterName = meterObj ? meterObj.name : '';
    nameZip.push(meterName);
    nameZip.push(groupName.name);
    nameZip.push(month);
    nameZip.push(year);
    return nameZip.join('-');
  };

  const handleDownloadZip = async () => {
    const zip = new JSZip();
    const zipName = invoiceName();
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      zIndex: 1000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    await Promise.all(
      selectedRows.map(async (row) => {
        try {
          const response = await axios.get(row.url_stream, {
            responseType: 'blob',
          });
          zip.file(`${row.charge_name}.pdf`, response.data);
          Toast.fire({
            icon: 'success',
            title: intl.formatMessage({
              id: 'app.invoices.downloadMessageSuccess',
            }),
          });
        } catch (error) {
          const errorMessage = error.message;
          console.error(
            `Error al descargar el archivo ${row.charge_name}: ${errorMessage}`
          );
          Toast.fire({
            icon: 'error',
            title: intl.formatMessage({
              id: 'app.invoices.downloadMessageFailure',
            }),
          });
        }
      })
    );

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, `${zipName}.zip`);
    });
  };

  const DownloadButton = ({ selectedRows, allRows }) => {
    const handleDownloadZip = async (rows) => {
      if (rows.length === 0) return;

      const zip = new JSZip();
      const zipName = `RECIBOS${invoiceName()}`;
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        zIndex: 1000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });

      await Promise.all(
        rows.map(async (row) => {
          if (!row.url_stream) return; // Evitar errores si la URL no existe

          try {
            const response = await axios.get(row.url_stream, {
              responseType: 'blob',
            });
            zip.file(`${row.charge_name}.pdf`, response.data);
          } catch (error) {
            console.error(`Error al descargar ${row.charge_name}:`, error);
            Toast.fire({
              icon: 'error',
              title: 'Error al descargar un archivo',
            });
          }
          Toast.fire({
            icon: 'success',
            title: 'Descarga exitosa',
          });
        })
      );

      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, `${zipName}.zip`);
      });
    };

    return (
      <Box sx={{ display: 'flex', gap: 2 }}>
        {/* Descargar Seleccionados */}
        <Button
          color="primary"
          disabled={selectedRows.length === 0}
          onClick={() => handleDownloadZip(selectedRows)}
          variant="contained"
        >
          Descargar Seleccionados
        </Button>

        {/* Descargar Todos */}
        <Button
          color="secondary"
          disabled={allRows === undefined || allRows.length === 0}
          onClick={() => handleDownloadZip(allRows)}
          variant="contained"
        >
          Descargar Todos
        </Button>
      </Box>
    );
  };

  const getLinkReceipt = (url) => {
    if (url) {
      return (
        <Link className={classes.iconTable} download target="_blank" to={url}>
          <img
            alt=""
            border="0"
            height="40"
            src="/images/download_pdf.png"
            title={intl.formatMessage({
              id: 'app.invoices.linkReceipDonloadFac',
            })}
            width="40"
          />
        </Link>
      );
    } else {
      return (
        <img
          alt=""
          border="0"
          height="25"
          src="/images/cruz_roja.png"
          title={intl.formatMessage({ id: 'app.invoices.linkReceipNoAvail' })}
          width="25"
        />
      );
    }
  };

  const getLinkInvoice = (url) => {
    if (url) {
      return (
        <Link className={classes.iconTable} download target="_blank" to={url}>
          <img
            alt=""
            border="0"
            height="40"
            src="/images/download_pdf.png"
            title={intl.formatMessage({ id: 'app.invoices.linkInvDonloadFac' })}
            width="40"
          />
        </Link>
      );
    } else {
      return (
        <img
          alt=""
          border="0"
          height="25"
          src="/images/cruz_roja.png"
          title={intl.formatMessage({ id: 'app.invoices.linkInvNoAvail' })}
          width="25"
        />
      );
    }
  };

  const getLinkInvoiceXML = (url) => {
    if (url) {
      return (
        <Link className={classes.iconTable} download target="_blank" to={url}>
          <img
            alt=""
            border="0"
            height="40"
            src="/images/download_xml.png"
            title={intl.formatMessage({
              id: 'app.invoices.linkInvDonloadFacXML',
            })}
            width="40"
          />
        </Link>
      );
    } else {
      return (
        <img
          alt=""
          border="0"
          height="25"
          src="/images/cruz_roja.png"
          title={intl.formatMessage({ id: 'app.invoices.linkInvNoAvailXML' })}
          width="25"
        />
      );
    }
  };

  const columns = getColumns(
    intl,
    getLinkReceipt,
    getLinkInvoice,
    getLinkInvoiceXML
  );

  return (
    <DashboardLayout title="Reportes">
      <Box
        sx={{
          my: 4,
          mx: 3,
          bgcolor: 'white',
        }}
      >
        <Box sx={{ bgcolor: 'white', p: 4, borderRadius: 1, boxShadow: 1 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container={true} spacing={3}>
              <Grid2
                size={{
                  lg: getSelector(user.adser) === null ? 0 : 3,
                  md: getSelector(user.adser) === null ? 0 : 6,
                  xs: getSelector(user.adser) === null ? 0 : 6,
                }}
              >
                {getSelector(user?.adser)}
              </Grid2>
              <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
                <FormControl
                  className={classes.textField}
                  variant="outlined"
                  fullWidth={true}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    {intl.formatMessage({ id: 'app.invoices.meterLbl' })}
                  </InputLabel>
                  <Select
                    id="demo-simple-select-outlined"
                    {...register('meter')}
                    labelId="demo-simple-select-outlined-label"
                    name="meter"
                    onChange={handleMeter}
                    value={meter}
                    input={
                      <OutlinedInput
                        label={intl.formatMessage({
                          id: 'app.reports.hourReports.meterLbl',
                        })}
                      />
                    }
                  >
                    {meters?.map((el) => (
                      <MenuItem value={el.id} key={el.id}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
                <FormControl
                  className={classes.textField}
                  variant="outlined"
                  fullWidth={true}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    {intl.formatMessage({ id: 'app.invoices.groupLbl' })}
                  </InputLabel>
                  <Select
                    id="demo-simple-select-outlined"
                    {...register('group')}
                    labelId="demo-simple-select-outlined-label"
                    name="group"
                    onChange={handleGroup}
                    value={group}
                    input={
                      <OutlinedInput
                        label={intl.formatMessage({
                          id: 'app.invoices.groupLbl',
                        })}
                      />
                    }
                  >
                    {groups?.map((el) => (
                      <MenuItem value={el.id} key={el.id}>
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
                <FormControl
                  className={classes.textField}
                  variant="outlined"
                  fullWidth={true}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    {intl.formatMessage({ id: 'app.invoices.chargeLbl' })}
                  </InputLabel>
                  <Select
                    id="demo-simple-select-outlined"
                    {...register('group')}
                    labelId="demo-simple-select-outlined-label"
                    multiple
                    name="charge"
                    onChange={handleCharge}
                    value={charge}
                    input={
                      <OutlinedInput
                        label={intl.formatMessage({
                          id: 'app.invoices.chargeLbl',
                        })}
                      />
                    }
                    renderValue={(selected) => {
                      if (selected.length === 0) return 'Seleccione grupos';
                      return selected
                        .map((value) => {
                          const charegName = charges.find(
                            (charge) => charge.id === value
                          );
                          return charegName ? charegName.name : '';
                        })
                        .join(', ');
                    }}
                  >
                    <MenuItem value="TODAS">
                      <Checkbox checked={charge.indexOf('TODAS') > -1} />
                      TODAS
                    </MenuItem>
                    {charges?.map((el) => (
                      <MenuItem value={el.id} key={el.id}>
                        <Checkbox checked={charge.indexOf(el.id) > -1} />
                        {el.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
                <FormControl
                  className={classes.textField}
                  variant="outlined"
                  fullWidth={true}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    {intl.formatMessage({ id: 'app.invoices.yearLbl' })}
                  </InputLabel>
                  <Select
                    id="demo-simple-select-outlined"
                    {...register('year')}
                    labelId="demo-simple-select-outlined-label"
                    name="year"
                    onChange={handleYear}
                    value={year}
                    input={
                      <OutlinedInput
                        label={intl.formatMessage({
                          id: 'app.invoices.yearLbl',
                        })}
                      />
                    }
                  >
                    {years.map((yr) => (
                      <MenuItem value={yr} key={yr}>
                        {yr}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid2>
              <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
                <FormControl
                  className={classes.textField}
                  variant="outlined"
                  fullWidth={true}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    {intl.formatMessage({ id: 'app.invoices.monthLb' })}
                  </InputLabel>
                  <Select
                    id="demo-simple-select-outlined"
                    {...register('month')}
                    labelId="demo-simple-select-outlined-label"
                    name="month"
                    onChange={handleMonth}
                    value={month}
                    input={
                      <OutlinedInput
                        label={intl.formatMessage({
                          id: 'app.invoices.monthLb',
                        })}
                      />
                    }
                  >
                    <MenuItem value="01">
                      {intl.formatMessage({ id: 'app.months.jan' })}
                    </MenuItem>
                    <MenuItem value="02">
                      {intl.formatMessage({ id: 'app.months.feb' })}
                    </MenuItem>
                    <MenuItem value="03">
                      {intl.formatMessage({ id: 'app.months.mar' })}
                    </MenuItem>
                    <MenuItem value="04">
                      {intl.formatMessage({ id: 'app.months.apr' })}
                    </MenuItem>
                    <MenuItem value="05">
                      {intl.formatMessage({ id: 'app.months.may' })}
                    </MenuItem>
                    <MenuItem value="06">
                      {intl.formatMessage({ id: 'app.months.jun' })}
                    </MenuItem>
                    <MenuItem value="07">
                      {intl.formatMessage({ id: 'app.months.jul' })}
                    </MenuItem>
                    <MenuItem value="08">
                      {intl.formatMessage({ id: 'app.months.ago' })}
                    </MenuItem>
                    <MenuItem value="09">
                      {intl.formatMessage({ id: 'app.months.sep' })}
                    </MenuItem>
                    <MenuItem value="10">
                      {intl.formatMessage({ id: 'app.months.oct' })}
                    </MenuItem>
                    <MenuItem value="11">
                      {intl.formatMessage({ id: 'app.months.nov' })}
                    </MenuItem>
                    <MenuItem value="12">
                      {intl.formatMessage({ id: 'app.months.dec' })}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid2>
              <Button
                className={classes.signUpButton}
                color="primary"
                size="large"
                type="submit"
                loading={blocking}
                variant="contained"
                loadingPosition="start"
              >
                {blocking
                  ? 'Cargando...'
                  : intl.formatMessage({
                      id: 'app.invoices.searchBtn',
                    })}
              </Button>
            </Grid2>
          </form>
          <Box sx={{ mt: 4, height: 450 }}>
            <DataGrid
              rows={data}
              columns={columns}
              getRowId={(row) => row.charge_id}
              disableRowSelectionOnClick
              checkboxSelection
              onRowSelectionModelChange={(newSelection) => {
                const selected = data.filter((row) =>
                  newSelection.includes(row.charge_id)
                );
                setSelectedRows(selected);
              }}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5, // Configura el tamaño de página
                  },
                },
              }}
              slots={{
                footer: () => (
                  <CustomFooterDownloadComponent
                    selectedRows={selectedRows}
                    data={data}
                  />
                ),
                toolbar: QuickSearchToolbar,
                noRowsOverlay: () => <EmptyTable text="Sin Busquedas" />,
              }}
              sx={{
                borderRadius: 2,
                boxShadow: 3,
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                '& .MuiDataGrid-root': {
                  border: 'none', // Quita el borde
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de las celdas
                  maxHeight: '60px', // Máxima altura de las celdas
                },
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de los encabezados
                },
                '& .MuiDataGrid-row': {
                  borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de las filas
                  maxHeight: '60px', // Máxima altura de las filas
                },
              }}
            />
          </Box>
        </Box>
      </Box>
      <SpeedDial
        ariaLabel="SendInvoice"
        sx={{
          position: 'fixed',
          bottom: 32,
          right: 32,
          '& .MuiFab-primary': {
            width: 80, // Ajusta el tamaño del botón principal
            height: 80,
            backgroundColor: '#A53693', // Cambia el color de fondo
            '&:hover': {
              backgroundColor: '#6A1A5F',
            },
          },
        }}
        icon={
          <Settings
            sx={{
              width: 40,
              height: 40,
              transform: 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'rotate(180deg)',
                backgroundColor: '#6A1A5F',
              },
            }}
          />
        }
      >
        <SpeedDialAction
          icon={<Email />}
          tooltipTitle="Programar Envios"
          onClick={() => setOpen(true)}
          sx={{
            backgroundColor: '#00AFEF',
            color: '#fff',
            width: '60px',
            height: '60px',
            fontSize: '1.5em',
            '&:hover': {
              backgroundColor: 'rgb(0, 146, 199)',
            },
          }}
        />
      </SpeedDial>
      <SendInvoice open={open} setOpen={setOpen} />
    </DashboardLayout>
  );
}
